import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * FASE 18.4 — landing route for Google Calendar deep links.
 * Resolves the schedule into an open execution and jumps to the runner.
 */
export default function ExecutionGo() {
  const { scheduleId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.post(`/checklists/schedules/${scheduleId}/resolve`);
        if (!cancelled) navigate(`/executions/${data.execution_id}`, { replace: true });
      } catch (err) {
        if (!cancelled) {
          toast.error(err?.response?.data?.detail || "Checklist não disponível");
          navigate("/dashboard", { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [scheduleId, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-stone-50 gap-3"
      data-testid="execution-go-loading"
    >
      <Loader2 className="h-8 w-8 animate-spin text-emerald-700" />
      <p className="font-body text-sm text-stone-500">Abrindo seu checklist...</p>
    </div>
  );
}
